import '../scss/app.scss';
// import './dist/app.css?raw';

import { domReady } from './utilities/helpers.js';
import framework from './framework.js';
// assets/scss/app.scss
function start() {
  framework();
}
domReady(start);